import React, { useState } from "react";
import "react-day-picker/dist/style.css";
import "./style.scss";
import { HiOutlineTicket } from "react-icons/hi";
import { BiInfoCircle } from "react-icons/bi";
import HtmlTooltip from "@mui/material/Tooltip";
import { AiOutlineIdcard } from "react-icons/ai";
import useExerciseInfo from "../../ScheduleExercise/exerciseInfo/useExerciseInfo";
import useSchedule from "../../ScheduleExercise/hooks/useSchedule";
import { Exercise } from "../../../models/Exercise";
import { IoMdCheckmark } from "react-icons/io";
import { IoPersonAddOutline } from "react-icons/io5";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import ModalComponent from "../../../../features/ModalComponent";
import { useTranslation } from "react-i18next";
import format from "date-fns/format";
import { Popper } from "@mui/material";
interface IProps {
  asignByPass: (assignType: boolean, passId: number) => void;
  exerciseDetails?: Exercise;
  alertCalendar: string;
}
const CalendarPassReservaton: React.FC<IProps> = ({ asignByPass, exerciseDetails, alertCalendar }: IProps) => {
  const { availablePasses } = useExerciseInfo();
  const isDesktop = useDesktopSize();
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();
  return (
    <React.Fragment>
      {availablePasses && (
        <React.Fragment>
          {alertCalendar.length > 3 && <div className="alert alert-red">
            {alertCalendar}
          </div>}
          <div className="horizontal-line"></div>
          {availablePasses.map((item, index) =>
            <div key={index}>
              {item.ticket === false && item.passtype === 2 && <div
                className={"pass-line ticket-line flex-between-center"}
              >
                <div className="ticket-line-left flex-start-center">
                  <div className="flex-between-center">
                    <AiOutlineIdcard className="ticket-line-icon" />
                    <b>{item.name}</b>
                  </div>
                  <React.Fragment>
                    {item.description.length > 2 && (
                      <React.Fragment>
                        {isDesktop ? (
                          <HtmlTooltip
                            placement="right"
                            arrow={true}
                            title={
                              <React.Fragment>
                                <div
                                  className="tooltip-description">

                                  <div>

                                    <p>Nazwa karnetu: <b>{item.name}</b></p>
                                    <p>Pozostała ilość rezerwacji: <b>{item.entrances - item.exercises.length}</b></p>
                                    <p>Karnet ważny: <b>
                                      {format(item.validfrom, "dd.MM")} - {format(item.validto, "dd.MM.yyyy")}</b></p>
                                  </div>

                                </div>
                              </React.Fragment>
                            }
                          >
                            <b>
                              <BiInfoCircle className="tooltip-icon" />
                            </b>
                          </HtmlTooltip>
                        ) : (
                          <b onClick={() => setOpen(!open)}>
                            <BiInfoCircle className="tooltip-icon" />
                          </b>
                        )}
                      </React.Fragment>
                    )}
                  </React.Fragment>
                </div>
                <div className="ticket-line-right flex-end-center">
                  {exerciseDetails &&
                    <React.Fragment>
                      {exerciseDetails.assigned ? (
                        <React.Fragment>
                          <HtmlTooltip
                            placement="top-start"
                            title={
                              <React.Fragment>
                                <article
                                  className="tooltip-description"
                                  dangerouslySetInnerHTML={{ __html: "Kliknij, aby zrezygnować z tej rezerwacji." }}
                                ></article>
                              </React.Fragment>
                            }
                          >
                            <button className="flex-center-center button small padding-medium button-fill-background-second"
                              onClick={() => asignByPass(true, item.objectId
                              )}
                            >
                              <IoMdCheckmark className="icon" />
                              Jesteś zapisany
                            </button>
                          </HtmlTooltip>
                        </React.Fragment>
                      )
                        : (
                          <React.Fragment>
                            {item.entrances - item.exercises.length > 0 ? (<button className="flex-center-center button small padding-medium button-outline-second"
                              onClick={() => asignByPass(false, item.objectId
                              )}
                            >
                              <IoPersonAddOutline className="icon-second" />

                              Zapisz się karnetem
                            </button>) : (<button className="flex-center-center button small padding-medium button-fill-disable"
                              onClick={() => asignByPass(false, item.objectId
                              )}
                            >
                              <IoPersonAddOutline className="icon-second" />

                              Wykorzystano
                            </button>)}
                          </React.Fragment>
                        )
                      }
                    </React.Fragment>}

                </div>
              </div>}
              {open && (
                <div className="schedule-modal-info">
                  <ModalComponent
                    footer={false}
                    open={open}
                    closeModal={() => setOpen(false)}
                    title={item.name}
                    onAccept={() => setOpen(false)}
                    acceptText={t("przeczytalem")}
                  >
                    {item.description.length > 1 ? (
                      <p className="news-modal-body" dangerouslySetInnerHTML={{ __html: item.description }}></p>
                    ) : (
                      <p className="news-modal-body">{t("brak_opisu")}</p>
                    )}
                  </ModalComponent>
                </div>
              )}
            </div>



          )}
        </React.Fragment>
      )}


    </React.Fragment>
  );
};

export default CalendarPassReservaton;
